<div class="card">
  <div class="row">
    <div class="mb-3 text-left font-medium text-md">
      <span class="text-primary-700">
        <p-button
          icon="pi pi-arrow-left"
          [rounded]="true"
          [outlined]="true"
          severity="primary"
          [styleClass]="'back-button'"
          (click)="goToBack()"
        ></p-button>
        Revisión de Solicitud
      </span>
      <span class="text-900">
        | {{ application.applicant.name }} {{ application.applicant.lastName }},
        {{ calculateYearsOld(application.applicant.birthDay) }} Años | {{application.club.name}} |   <p-tag
        [severity]="getApplicationTypeDisplay().severity"
        [rounded]="true"
        [value]="getApplicationTypeDisplay().label"
      /></span
      >
    </div>
    <div class="flex mb-2 gap-2 justify-content-end">
      <p-button
        (click)="activeIndex = 0"
        [rounded]="true"
        styleClass="w-2rem h-2rem p-0"
        [outlined]="activeIndex !== 0"
        label="1"
      ></p-button>
      <p-button
        (click)="activeIndex = 1"
        [rounded]="true"
        styleClass="w-2rem h-2rem p-0"
        [outlined]="activeIndex !== 1"
        label="2"
      ></p-button>
      <p-button
        (click)="activeIndex = 2"
        [rounded]="true"
        styleClass="w-2rem h-2rem p-0"
        [outlined]="activeIndex !== 2"
        label="3"
      ></p-button>
      <p-button
      (click)="activeIndex = 3"
      [rounded]="true"
      styleClass="w-2rem h-2rem p-0"
      [outlined]="activeIndex !== 3"
      label="4"
    ></p-button>
      <p-button
        *ngIf="shouldShowPaymentTab()"
        (click)="activeIndex = 4"
        [rounded]="true"
        styleClass="w-2rem h-2rem p-0"
        [outlined]="activeIndex !== 4"
        label="5"
      ></p-button>
    </div>
  </div>

  <p-tabView [(activeIndex)]="activeIndex">
    <p-tabPanel>
      <ng-template pTemplate="header">
        <i class="pi pi-user"></i>
        <span class="ml-1"> Información Personal</span>
      </ng-template>

      <div class="surface-section">
        <ul class="list-none p-0 m-0">
          <li
          class="flex align-items-center py-2 px-1 border-bottom-1 surface-border flex-wrap"
        >
          <div class="text-500 w-6 md:w-2 font-medium">Tipo Solicitud</div>
          <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
            <div class="flex align-items-center gap-2">
              <p-tag
                [severity]="getApplicationTypeDisplay().severity"
                [rounded]="true"
                [value]="getApplicationTypeDisplay().label"
              />
              <span *ngIf="getApplicationTypeDisplay().isSuggestion" class="text-sm text-500">
                (Basado en historial)
              </span>
            </div>
          </div>
          <div *ngIf="legacyData.length > 0" class="w-6 md:w-2 flex justify-content-end">
            <button
              pButton
              pRipple
              label="Ver Historial"
              icon="pi pi-eye"
              class="p-button-text"
              (click)="showLegacyInfo()"
            ></button>
          </div>
        </li>
          <li
            class="flex align-items-center py-2 px-1 border-bottom-1 surface-border flex-wrap"
          >
            <div class="text-500 w-6 md:w-2 font-medium">Club</div>
            <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
    
              <div>
                {{ application.club.name}}
              </div>
            </div>
          </li>
          <li
            class="flex align-items-center py-2 px-1 border-bottom-1 surface-border flex-wrap"
          >
            <div class="text-500 w-6 md:w-2 font-medium">
              Modalidad
            </div>
            <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">

              <div>
                {{
                  application.modalidad
                }}
              </div>
            </div>
          </li>
          <li
          class="flex align-items-center py-2 px-1 border-bottom-1 surface-border flex-wrap"
        >
          <div class="text-500 w-6 md:w-2 font-medium">
            Rol
          </div>
          <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">

            <div>
              {{
                application.rol
              }}
            </div>
          </div>
        </li>
          <li
          class="flex align-items-center py-2 px-1 border-bottom-1 surface-border flex-wrap"
        >
          <div class="text-500 w-6 md:w-2 font-medium">Nivel</div>
          <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
            <p-tag
            [severity]="application.nivel === 'LIGA' ? 'success': 'info'"
            [rounded]="true"
            [value]="application.nivel"
          />
          </div>
        </li>
          <li
            class="flex align-items-center py-2 px-1 border-bottom-1 surface-border flex-wrap"
          >
            <div class="text-500 w-6 md:w-2 font-medium">Nombre</div>
            <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
              {{ application.applicant.name }}
              {{ application.applicant.lastName }}
            </div>
          </li>
          <li
            class="flex align-items-center py-2 px-1 border-bottom-1 surface-border flex-wrap"
          >
            <div class="text-500 w-6 md:w-2 font-medium">Identificación</div>
            <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
              {{ application.applicant.idType }}
              {{ application.applicant.idNumber }}
            </div>
          </li>
          <li
            class="flex align-items-center py-2 px-1 border-bottom-1 surface-border flex-wrap"
          >
            <div class="text-500 w-6 md:w-2 font-medium">Género</div>
            <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
              {{
                application.applicant.gender === "M"
                  ? "Masculino"
                  : application.applicant.gender === "F"
                  ? "Femenino"
                  : application.applicant.gender === "NB"
                  ? "No Binario"
                  : application.applicant.gender
              }}
            </div>
          </li>
          <li
            class="flex align-items-center py-2 px-1 border-bottom-1 surface-border flex-wrap"
          >
            <div class="text-500 w-6 md:w-2 font-medium">
              Fecha de Nacimiento
            </div>
            <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
              {{ application.applicant.birthDay }}
            </div>
          </li>
          <li
            class="flex align-items-center py-2 px-1 border-bottom-1 surface-border flex-wrap"
          >
            <div class="text-500 w-6 md:w-2 font-medium">Edad Actual</div>
            <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
              {{ calculateYearsOld(application.applicant.birthDay) }} Años
            </div>
          </li>
          <li
            class="flex align-items-center py-2 px-1 border-bottom-1 surface-border flex-wrap"
          >
            <div class="text-500 w-6 md:w-2 font-medium">Teléfono</div>
            <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
              {{ application.applicant.contactInformation.telephone }}
            </div>
          </li>
          <li
            class="flex align-items-center py-2 px-1 border-bottom-1 surface-border flex-wrap"
          >
            <div class="text-500 w-6 md:w-2 font-medium">Email</div>
            <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
              {{ application.applicant.contactInformation.email }}
            </div>
          </li>
          <li
            class="flex align-items-center py-2 px-1 border-bottom-1 surface-border flex-wrap"
          >
            <div class="text-500 w-6 md:w-2 font-medium">EPS</div>
            <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
              {{ application.applicant.assistanceInformation.insurance }}
            </div>
          </li>
        </ul>
      </div>
    </p-tabPanel>
    <p-tabPanel>
      <ng-template pTemplate="header">
        <i class="pi pi-file"></i>
        <span class="ml-1">Documentos</span>
      </ng-template>
      <div class="surface-section">
        <ul class="list-none p-0 m-0">
          <li
            class="flex align-items-center py-2 px-1 border-bottom-1 surface-border flex-wrap"
            *ngFor="
              let document of application.documents.docmuentsToSend;
              index as i
            "
          >
            <div class="text-500 w-6 md:w-2 font-medium">
              Documento N° {{ i + 1 }}
            </div>
            <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
              {{
                document.id === "docId"
                  ? "Documento de Identificación"
                  : document.id === "docEps"
                  ? "Certificado de Eps"
                  : document.id === "docDisclaimer"
                  ? "Consentimiento Informado"
                  : document.id === "docSponsor"
                  ? "Soporte Convenio"
                  : document.id
              }}
            </div>
            <div class="w-6 md:w-2 flex justify-content-end">
              <button
                pButton
                pRipple
                label="Ver"
                icon="pi pi-eye"
                class="p-button-text"
                (click)="showPreview(document)"
              ></button>
            </div>
          </li>
        </ul>
      </div>
    </p-tabPanel>
    <p-tabPanel>
      <ng-template pTemplate="header">
        <i class="pi pi-image"></i>
        <span class="ml-1">Foto</span>
      </ng-template>
      <div class="surface-section">
        <div class="flex justify-content-center">
          <img
            [src]="application.picture"
            alt="Foto del solicitante"
            class="applicant-picture"
          />
        </div>
      </div>
    </p-tabPanel>
    <p-tabPanel
      *ngIf="
        application.process?.processStage === 'created' ||
        application.process?.processStage === 'queued'
      "
    >
      <ng-template pTemplate="header">
        <i class="pi pi-verified"></i>
        <span class="ml-1">Confirmación</span>
      </ng-template>
      <div class="card flex justify-content-center">
        <p-selectButton
          [options]="stateOptions"
          [(ngModel)]="confirmationResponse"
          optionLabel="label"
          optionValue="value"
        ></p-selectButton>
      </div>

      <div *ngIf="confirmationResponse === 'accepted_payment_pending'">
        <p-card
          header="Asignación de productos y servicios"
          class="mt-2"
          subheader="Selecciona el tipo de solicitud y los productos y/o servicios que debe pagar el usuario para continuar con la vinculación"
        >
          <div class="row">
            <span class="p-float-label m-2">
              <p-dropdown
                [options]="applicationTypeOptions"
                [(ngModel)]="selectedApplicationType"
                optionLabel="label"
                optionValue="value"
                inputId="applicationTypeSelect"
                [style]="{ width: '100%' }"
              ></p-dropdown>
              <label for="applicationTypeSelect">Tipo de Solicitud *</label>
            </span>
          </div>
          <div class="row">
            <span class="p-float-label m-2">
              <p-multiSelect
                display="chip"
                [showClear]="true"
                [style]="{ display: 'flex' }"
                [options]="productos"
                [(ngModel)]="productosAsignados"
                optionLabel="name"
                inputId="assignedProductsSelect"
              ></p-multiSelect>
              <label for="">Productos y Servicios *</label>
            </span>
          </div>
          <div class="justify-content-center flex mt-4">
            <p-button
              (click)="sendResponse($event)"
              icon="pi pi-check"
              label="Enviar Respuesta"
              [disabled]="
                productosAsignados.length === 0 || !selectedApplicationType
              "
            ></p-button>
          </div>
        </p-card>
        <p-toast [baseZIndex]="1200"></p-toast>
        <p-confirmDialog></p-confirmDialog>
      </div>

      <div *ngIf="confirmationResponse === 'rejected'">
        <p-card
          header="Comentarios"
          class="mt-2"
          subheader="Ingrese la descripción del motivo de rechazo de la solicitud"
        >
          <div class="row">
            <span class="p-float-label inline-block m-2">
              <textarea
                rows="5"
                cols="30"
                pInputTextarea
                [(ngModel)]="rejectComments"
              ></textarea>
              <label for="float-label" class="mr-2">Comentarios* </label>
            </span>
          </div>
          <div class="justify-content-center flex mt-2">
            <p-button
              (click)="sendResponse($event)"
              icon="pi pi-check"
              label="Enviar Respuesta"
            ></p-button>
          </div>

          {{ productosAsignados }}
        </p-card>

        <p-toast [baseZIndex]="1200"></p-toast>
        <p-confirmDialog></p-confirmDialog>
      </div>
    </p-tabPanel>
    <p-tabPanel *ngIf="shouldShowPaymentTab()">
      <ng-template pTemplate="header">
        <i class="pi pi-credit-card"></i>
        <span class="ml-1">Items de Pago</span>
      </ng-template>
      <div class="surface-section">
        <div *ngIf="application.payment && application.payment.paymentItems && application.payment.paymentItems.length > 0; else noPaymentItems">
          <ul class="list-none p-0 m-0">
            <li
              class="flex align-items-center py-3 px-2 border-bottom-1 surface-border flex-wrap"
              *ngFor="let item of application.payment.paymentItems; index as i"
            >
              <div class="text-500 w-6 md:w-2 font-medium">
                Item {{ i + 1 }}
              </div>
              <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
                <div class="mb-2">
                  <strong>Descripción:</strong> {{ item.descripcion }}
                </div>
                <div class="mb-2">
                  <strong>Tipo:</strong> {{ item.tipo }}
                </div>
                <div class="mb-2">
                  <strong>Valor Unitario:</strong> {{ item.valorUnitario | currency:'COP':'symbol':'1.0-0' }}
                </div>
                <div class="mb-2">
                  <strong>IVA:</strong> {{ item.porcentajeIva }}%
                </div>
                <div class="mb-2">
                  <strong>Valor Total:</strong> 
                  <span class="font-bold text-primary">{{ item.valorTotal | currency:'COP':'symbol':'1.0-0' }}</span>
                </div>
              </div>
            </li>
          </ul>
          <div class="mt-3 p-3 surface-100 border-round">
            <div class="flex justify-content-between align-items-center">
              <span class="text-lg font-bold">Total a Pagar:</span>
              <span class="text-xl font-bold text-primary">
                {{ getTotalPayment() | currency:'COP':'symbol':'1.0-0' }}
              </span>
            </div>
            <div class="mt-2">
              <span class="text-sm text-500">Estado del Pago: </span>
              <p-tag
                [value]="getPaymentStatusLabel(application.process!.processStage!)"
                [severity]="getPaymentStatusSeverity(application.process!.processStage!)"
                [rounded]="true"
              />
            </div>
          </div>
        </div>
        <ng-template #noPaymentItems>
          <div class="text-center p-5">
            <i class="pi pi-info-circle text-3xl text-500 mb-3"></i>
            <p class="text-500 text-lg">No hay items de pago asignados para esta solicitud.</p>
          </div>
        </ng-template>
      </div>
    </p-tabPanel>
  </p-tabView>
</div>
<p-dialog
  *ngIf="showDocumentPreview"
  [header]="documentPreviewSelected.documentName"
  [(visible)]="showDocumentPreview"
  [modal]="true"
  [style]="{ width: '60vw', height: '70vh' }"
  [draggable]="false"
  [resizable]="false"
>
  <iframe
    allowfullscreen
    [src]="documentPreviewSelected.base64"
    [title]="documentPreviewSelected.documentName"
    class="responsive-iframe"
  ></iframe>
</p-dialog>

<p-dialog
  *ngIf="showLegacyMemberInfo"
  header="Información de Vinculaciones Previas"
  [(visible)]="showLegacyMemberInfo"
  [modal]="true"
  [style]="{ width: '60vw'}"
  [draggable]="false"
  [resizable]="false"
>

<div *ngFor="let legacy of legacyData">
  <p-card [header]="legacy.nombres + ' ' +legacy.apellidos" [subheader]="legacy.rol">
    <ng-template pTemplate="content">
      <div>
        <ul class="list-none p-0 m-0">
          <li
            class="flex align-items-center py-2 px-1 border-bottom-1 surface-border flex-wrap"
          >
            <div class="text-500 w-6 md:w-2 font-medium">Club</div>
            <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
              {{ legacy.club }}
            </div>
          </li>
          <li
            class="flex align-items-center py-2 px-1 border-bottom-1 surface-border flex-wrap"
          >
            <div class="text-500 w-6 md:w-2 font-medium">Categoría</div>
            <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
              {{ legacy.categoria }}
            </div>
          </li>
          <li
            class="flex align-items-center py-2 px-1 border-bottom-1 surface-border flex-wrap"
          >
            <div class="text-500 w-6 md:w-2 font-medium">Nivel</div>
            <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
              <p-tag
                [severity]="legacy.nivel === 'LIGADOS' ? 'success': 'info'"
                [rounded]="true"
                [value]="legacy.nivel"
              />
            </div>
          </li>
          <li
            class="flex align-items-center py-2 px-1 border-bottom-1 surface-border flex-wrap"
          >
            <div class="text-500 w-6 md:w-2 font-medium">Fecha de Renovación</div>
            <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
              {{ legacy.ultimaRenovacion }}
            </div>
          </li>
        </ul>
      </div>
    </ng-template>
    <ng-template pTemplate="footer"></ng-template>

</p-card>
</div>

</p-dialog>

